import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import UploadForm from './UploadForm';
import { defaultEmployeeSlug } from './employees';

function RootRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/${defaultEmployeeSlug}${search}`} replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/:employeeSlug" element={<UploadForm />} />
      </Routes>
    </Router>
  );
}

export default App;
